import modules_wiki from './wiki/index.js'
import modules_style from './style/index.js'
import modules_setting from './setting/index.js'
import modules_permit from './permit/index.js'
import modules_menu from './menu/index.js'
import modules_events from './events/index.js'
import _actions_promptNoFeature from './_actions/promptNoFeature.js'
import _actions_logout from './_actions/logout.js'
import _actions_get from './_actions/get.js'
import _getters_permit from './_getters/permit.js'
import _getters_loading from './_getters/loading.js'
import _getters_hasFeature from './_getters/hasFeature.js'
import _mutations_set from './_mutations/set.js'
import _mutations_loading from './_mutations/loading.js'
import _mutations_clean from './_mutations/clean.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        clean: _mutations_clean,
        loading: _mutations_loading,
        set: _mutations_set,
    },
    getters:{
        hasFeature: _getters_hasFeature,
        loading: _getters_loading,
        permit: _getters_permit,
    },
    actions:{
        get: _actions_get,
        logout: _actions_logout,
        promptNoFeature: _actions_promptNoFeature,
    },
    modules:{
        events: modules_events,
        menu: modules_menu,
        permit: modules_permit,
        setting: modules_setting,
        style: modules_style,
        wiki: modules_wiki,
    },
}